import { createRoot } from 'react-dom/client'
import { createInertiaApp, router } from '@inertiajs/react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import '../app.css'

// When Rails session expires, Inertia XHR gets a non-Inertia response (Devise login page).
// Force a full browser navigation so the redirect to login works correctly.
router.on('invalid', (event) => {
  event.preventDefault()
  window.location.href = event.detail.response.url || window.location.href
})

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })
    return pages[`../pages/${name}.jsx`]
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <>
        <App {...props} />
        <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      </>
    )
  },
})

// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
